import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import theme from '../../theme';

export const LoginBg = styled(Stack)({
  position: 'relative',
  width: '100%',
  height: '100vh',
  padding: '16px',
  backgroundColor: theme.palette.grey.w50
})

export const LoginBox = styled(Box)({
  margin: '-4% auto 0',
  padding: '56px 32px',
  borderRadius: '8px',
  boxShadow: `0 2px 6px ${theme.palette.grey.w300}`,
  backgroundColor: '#fff'
})

export const boxgreyLine = {
  borderBottom: `1px solid ${theme.palette.grey.w300}`,
  flex: '1 0 auto',
  height: '0.5em',
}

export const textsmGrey = {
  flex: '0.2 0 auto',
  fontSize: '0.75rem',
  textAlign: 'center',
  color: theme.palette.grey.w500,
  padding: '6px 0 0 0',
}
